export enum MemberType {
  MEMBER = 0,
  ADMIN = 1,
}

export enum DiscountType {
  NOT_DISCOUNT = 0,
  MAINTAIN_PRICE = 1,
  USING_FEE = 2,
}

export enum MitsumoriType {
  SOFTWARE = 1,
  TEMPLATE = 2,
  LICENSE = 3,
  USEWARE = 4,
  KDSS = 5,
  DISCOUNT = 9,
}

export enum MitsumoriKubun {
  REGISTER = 0,
  UPDATE = 1,
}

export enum UseType {
  IMPOSSIBLE = 0,
  POSSIBLE = 1,
}

export enum SumType {
  SUBTOTAL = 0,
  TOTAL = 1,
}
